var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.id,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": `${_vm.id}_label`,
      "aria-hidden": "true",
      "data-backdrop": _vm.backdrop
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    style: {
      'max-width': _vm.maxWidth
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [!_vm.headless ? _vm._t("header", function () {
    return [_c('div', {
      staticClass: "modal-header position-relative align-items-center"
    }, [_c('h5', {
      staticClass: "modal-title",
      attrs: {
        "id": `${_vm.id}_label`
      }
    }, [_vm._v(_vm._s(_vm.title))]), _vm.closeButton ? _c('button', {
      staticClass: "btn icon",
      attrs: {
        "type": "button",
        "aria-label": "Close",
        "disabled": _vm.locked || _vm.loading
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._m(0)]) : _vm._e(), _c('indeterminate-progress', {
      attrs: {
        "active": _vm.loading
      }
    })], 1)];
  }, null, {
    isOpen: _vm.isOpen,
    status: _vm.status,
    open: _vm.open,
    close: _vm.close
  }) : _vm._e(), _vm._t("default", null, null, {
    isOpen: _vm.isOpen,
    status: _vm.status,
    open: _vm.open,
    close: _vm.close
  })], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]);
}];
export { render, staticRenderFns };